import React, { forwardRef } from 'react'
import { pick } from 'lodash-es'
import { ProcessProvider, useDetailStore } from '@vt/hooks'
import OperationContent from './process-content/operationContent'

const Content = function ({ onClickSubmitProcess, detailFormRef, close }, ref) {
  const { currentData } = useDetailStore((state) =>
    pick(state, ['currentData'])
  )
  return (
    <ProcessProvider data={currentData}>
      <OperationContent
        ref={ref}
        onClickSubmitProcess={onClickSubmitProcess}
        detailFormRef={detailFormRef}
        close={close}
      />
    </ProcessProvider>
  )
}

export default forwardRef(Content)
